import Service from '@/services/abstract/service'

export default class Supervisor extends Service {
  constructor () {
    super()
    this._leadRef = this._db.collection(`${this._prefix}-leads`)
    this._equipeRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Empresas/${this._empresaPrincipal}/Equipes`
    )
    this._veiculoRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Veiculos`
    )
  }

  static separarColaboradores (base, maximo) {
    let resultado = [[]]
    let grupo = 0

    for (let i = 0; i < base.length; i++) {
      resultado[grupo].push(base[i].cpf_completo)
      if (resultado[grupo].length === maximo) {
        grupo++
        resultado.push([])
      }
    }

    return resultado
  }

  static separarLeads (base, maximo) {
    let resultado = [[]]
    let grupo = 0

    for (let i = 0; i < base.length; i++) {
      resultado[grupo].push(base[i].nomeVeiculo)
      if (resultado[grupo].length === maximo) {
        grupo++
        resultado.push([])
      }
    }

    return resultado
  }

  async getEquipes (cpfSupervisor) {
    try {
      this._loading.setLoading(true, 'Carregando Equipes')
      const response = await this._equipeRef
        .where('supervisor', '==', cpfSupervisor)
        .get()

      let equipes = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          equipes.push(doc.data())
        }
      }

      return Promise.resolve(equipes)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsByTemperatura (colaboradores, temperatura) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')

      let groupsColaboradores = Supervisor.separarColaboradores(
        colaboradores,
        10
      )

      let leads = new Array()
      for (const group of groupsColaboradores) {
        if (group.length > 0) {
          const response = await this._leadRef
            .where('donoDoLead', 'in', group)
            .where('termometro', '==', temperatura)
            .get()
          if (!response.empty) {
            for (let doc of response.docs) {
              leads.push({
                id: doc.id,
                ...doc.data()
              })
            }
          }
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsByDataCriacao (colaboradores, dateStart, dateEnd) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')
      let groupsColaboradores = Supervisor.separarColaboradores(
        colaboradores,
        10
      )

      let leads = new Array()
      for (const group of groupsColaboradores) {
        if (group.length > 0) {
          const response = await this._leadRef
            .where('donoDoLead', 'in', group)
            .where('dataCriacao', '>=', new Date(dateStart))
            .where('dataCriacao', '<=', new Date(dateEnd))
            .orderBy('dataCriacao', 'desc')
            .get()

          if (!response.empty) {
            for (let doc of response.docs) {
              leads.push({
                id: doc.id,
                ...doc.data()
              })
            }
          }
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getLeadsByDataProxContato (colaboradores, dateStart, dateEnd) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')
      let groupsColaboradores = Supervisor.separarColaboradores(
        colaboradores,
        10
      )

      let leads = new Array()
      for (const group of groupsColaboradores) {
        if (group.length > 0) {
          const response = await this._leadRef
            .where('donoDoLead', 'in', group)
            .where('dataProxContato', '>=', new Date(dateStart))
            .where('dataProxContato', '<=', new Date(dateEnd))
            .orderBy('dataProxContato', 'desc')
            .get()

          if (!response.empty) {
            for (let doc of response.docs) {
              leads.push({
                id: doc.id,
                ...doc.data()
              })
            }
          }
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async moveLeads (lead, para) {
    try {
      this._loading.setLoading(true, 'Movendo Lead')
      const response = this._leadRef.doc(lead.id)
      response
        .collection('historicoMovimentacao')
        .doc()
        .set({
          de: lead.donoDoLead,
          para,
          dataMovimentacao: new Date()
        })
      response.update({ donoDoLead: para })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
